import baseApi from "./baseApi"

export default  {
    async getProductCategories() {
        let request = await baseApi.createHttpRequest();
        let result = await request.get("/productCategory");
        return result.data;
    }
}